import { type PropsWithChildren, useEffect } from 'react';

import { useAuth } from '@sine/auth-client';

declare global {
  interface Window {
    /**
     * Extends the global Window interface to include New Relic Browser API methods.
     *
     * @see {@link https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/using-browser-apis/ | New Relic Using browser APIs documentation}
     */
    newrelic?: {
      /** Adds a user-defined identifier string to subsequent events on the page. */
      setUserId: (userId: string | null) => void;
    };
  }
}

function NewRelicProvider<T>({ children }: PropsWithChildren<T>) {
  const { userDetails } = useAuth();

  useEffect(() => {
    if (window.env.NEW_RELIC_ENABLED && window.newrelic && userDetails?.id) {
      window.newrelic.setUserId(userDetails.id);
    }
  }, [userDetails?.id]);

  return <>{children}</>;
}

export default NewRelicProvider;
